import * as THREE from 'three';

// Loads the original Ansoku textures from /public/assets when available, and degrades
// gracefully to tasteful solid colors when an asset is missing (so the game is always playable).

export interface SceneAssets {
  cubeMap: THREE.Texture | null;
  cubeNormal: THREE.Texture | null;
  boardMap: THREE.Texture | null;
  boardNormal: THREE.Texture | null;
  woodMap: THREE.Texture | null;
  socketMap: THREE.Texture | null;
  boardBaseMap: THREE.Texture | null;
}

const loader = new THREE.TextureLoader();

export function tryLoadTexture(url: string, srgb = true): Promise<THREE.Texture | null> {
  return new Promise((resolve) => {
    loader.load(
      url,
      (tex) => {
        tex.colorSpace = srgb ? THREE.SRGBColorSpace : THREE.NoColorSpace;
        tex.anisotropy = 8;
        tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
        resolve(tex);
      },
      undefined,
      () => resolve(null),
    );
  });
}

export async function loadSceneAssets(): Promise<SceneAssets> {
  const [cubeMap, cubeNormal, boardMap, boardNormal, woodMap, socketMap, boardBaseMap] =
    await Promise.all([
      tryLoadTexture('/assets/textures/Cube/BaseColor.png'),
      tryLoadTexture('/assets/textures/Cube/Normal.png', false),
      tryLoadTexture('/assets/textures/Board_Base_Color.png'),
      tryLoadTexture('/assets/textures/Board_Normal.png', false),
      tryLoadTexture('/assets/textures/WoodBaseTest.png'),
      tryLoadTexture('/assets/textures/BoardSocket.png'),
      tryLoadTexture('/assets/textures/BoardBase_Base_Color.png'),
    ]);
  return { cubeMap, cubeNormal, boardMap, boardNormal, woodMap, socketMap, boardBaseMap };
}

/** Ensure the Cinzel font is ready before we bake number textures. */
export async function ensureFonts(): Promise<void> {
  try {
    await Promise.all([
      (document as any).fonts.load('700 78px Cinzel'),
      (document as any).fonts.load('900 78px Cinzel'),
    ]);
    await (document as any).fonts.ready;
  } catch {
    /* fonts API unavailable — serif fallback is fine */
  }
}
